import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getRecentlyViewed } from "../lib/recentlyViewed";
import { useApp } from "../context/AppContext";

export default function RecentlyViewed({ excludeSlug }) {
  const [items, setItems] = useState([]);
  const { fmt } = useApp() || {};

  useEffect(() => {
    setItems(getRecentlyViewed(excludeSlug));
  }, [excludeSlug]);

  if (!items.length) return null;
  return (
    <section className="py-12 border-t border-ink/10" data-testid="recently-viewed-section">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <p className="text-xs uppercase tracking-[0.25em] text-ink/60 mb-3">Vos dernières visites</p>
        <h2 className="font-display text-2xl md:text-3xl mb-8">Récemment consultés</h2>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
          {items.slice(0, 5).map((p) => (
            <Link
              key={p.slug}
              to={`/produit/${p.slug}`}
              data-testid={`recently-viewed-item-${p.slug}`}
              className="group block"
            >
              <div className="aspect-square bg-ivory-200 rounded-xl overflow-hidden mb-2">
                {p.image ? (
                  <img src={p.image} alt={p.name} loading="lazy" decoding="async" className="w-full h-full object-cover group-hover:scale-105 transition" />
                ) : <div className="w-full h-full bg-ivory-300" />}
              </div>
              <p className="text-sm leading-tight line-clamp-2 group-hover:text-coral">{p.name}</p>
              {p.price != null && (
                <p className="text-xs text-ink/70 mt-1">{fmt ? fmt(p.price) : `${p.price} €`}</p>
              )}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
